<form [formGroup]="formUpdate" class="card p-3" (ngSubmit)="openDialog()">
    <div class="col">
      <div class="row">
        <h2 class="w-100">{{ 'AVISOS.UPDATE_CONTENTS' | translate }}</h2>
      </div>
    </div>
    <h6 class="w-100 subtitle">{{ 'AVISOS.TITLE' | translate }}</h6>
    <input placeholder="{{aviso.titulo}}" type="text" class="textbox-n w-100" formControlName="titulo" name="titulo">
    <h6 class="w-100 subtitle">{{ 'AVISOS.DESC' | translate }}</h6>
    <textarea placeholder="{{aviso.cuerpo}}" name="textarea" cols="40" rows="5" class="w-100" formControlName="cuerpo"></textarea>
    <h6 class="w-100 subtitle">{{ 'AVISOS.DOCUMENT' | translate }}</h6>
    <input type="file" class="px-0 py-0 btn m-left" accept="application/pdf" formControlName="documento" (change)="onFileChange($event)">
    <div class="mat-column-fecha w-100">
      <h6 class="w-100 subtitle">{{ 'PROCEDIMIENTOS.FORM.DATE_ACTIVE' | translate }}</h6>
      <div class="w-100 d-flex">
        <div class="w-100 d-flex " *ngIf="aviso.fechaApertura != null">
          <div class="dateDiv" >
            <input
              placeholder="{{('0'+aviso.fechaApertura[2]) | slice:-2}}/{{('0'+aviso.fechaApertura[1]) | slice:-2}}/{{('0'+aviso.fechaApertura[0]) | slice:-4}}"
              type="text" onfocus="(this.type='date')" onblur="if(this.value==''){this.type='text'}else this.type='date'"
              class=" textbox-n d-block widthDate" formControlName="fechaApertura">
          </div>
          <span style="width: 5%;"></span>
          <input placeholder="{{('0'+aviso.fechaApertura[3]) | slice:-2}}:{{('0'+aviso.fechaApertura[4]) | slice:-2}}" type="text"
            onfocus="(this.type='time')" onblur="(this.type='text')" class="textbox-n d-block widthTime"
            formControlName="horaApertura">
        </div>
        <div class="w-100 d-flex" *ngIf="aviso.fechaApertura == null">
          <div class="dateDiv">
            <input type="date" formControlName="fechaApertura" class="d-block ">
          </div>
          <span style="width: 5%;"></span>
          <input type="time" formControlName="horaApertura" class="d-block">
        </div>
      </div>
      <div *ngIf="fechaAperturaIncompletaWarning" class="alert alert-danger my-2">
        <p>{{ 'PROCEDIMIENTOS.FORM.DATE_INCOMPLETE' | translate }}</p>
      </div>
      <h6 class="w-100 subtitle">{{ 'PROCEDIMIENTOS.FORM.DATE_INACTIVE' | translate }}</h6>
      <div class="w-100 d-flex" >
        <div class="w-100 d-flex " *ngIf="aviso.fechaCierre != null">
          <div class="dateDiv">
            <input
              placeholder="{{('0'+aviso.fechaCierre[2]) | slice:-2}}/{{('0'+aviso.fechaCierre[1]) | slice:-2}}/{{('0'+aviso.fechaCierre[0]) | slice:-4}}"
              type="text" onfocus="(this.type='date')" onblur="if(this.value==''){this.type='text'}else this.type='date'"
              class=" textbox-n d-block widthDate" formControlName="fechaCierre">
          </div>
          <span style="width: 5%;"></span>
          <input placeholder="{{('0'+aviso.fechaCierre[3]) | slice:-2}}:{{('0'+aviso.fechaCierre[4]) | slice:-2}}" type="text"
            onfocus="(this.type='time')" onblur="(this.type='text')" class="textbox-n d-block widthTime"
            formControlName="horaCierre">
        </div>
        <div class="w-100 d-flex " *ngIf="aviso.fechaCierre == null">
          <div class="dateDiv">
            <input type="date" formControlName="fechaCierre" class="d-block ">
          </div>
          <span style="width: 5%;"></span>
          <input type="time" formControlName="horaCierre" class="d-block">
        </div>
      </div>
      <div *ngIf="fechaCierreIncompletaWarning" class="alert alert-danger my-2">
        <p>{{ 'PROCEDIMIENTOS.FORM.DATE_INCOMPLETE' | translate }}</p>
      </div>
    </div>
    <div class="w-100 d-flex mt-3">
      <div *ngIf="aviso.visible == true" class="mat-column-visible">
        <mat-checkbox [checked]=true (change)="updateVisibility($event)"></mat-checkbox>
      </div>
      <div *ngIf="aviso.visible == false" class="mat-column-visible">
        <mat-checkbox [checked]=false (change)="updateVisibility($event)"></mat-checkbox>
      </div>
      <h6 class="ml-3 subtitle my-0">{{ 'AVISOS.ACTIVE' | translate }}</h6>
    </div>
    <div class="w-100 d-flex mt-3 justify-content-between" >
      <button type="button" (click)="onNoClick()" class="py-2 btn btn-secondary m-left footer-btn">{{ 'COMMON.CANCEL' | translate }}</button>
      <button type="submit" class="py-2 btn  btn-primary m-left footer-btn">{{ 'AVISOS.SAVE' | translate }}</button>
    </div>
  </form>